module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"package":"Пакет","year":"рік","select":"Обрати","km":"км","one-time-payment":"Разовий платіж","submit":"Надіслати","success":"Надіслано!"},"en":{"package":"Package","year":"year","select":"Select","km":"km","one-time-payment":"One time payment","submit":"Submit","success":"Submitted!"}}')
  delete Component.options._Ctor
}
